import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        throw JSON.stringify({ error, errorInfo })
    }

    render() {
        return this.state.hasError ? (
            <>
                <h2>
                    <FormattedMessage id="toast.e.wrong" defaultMessage="Something went wrong" />
                </h2>
                <br></br>
                <h3>
                    <FormattedMessage id="toast.e.try.again" defaultMessage="Please try again!" />
                </h3>
            </>
        ) : (
            this.props.children
        )
    }
}
